import {
  GET_STUDENT_DATA,
  GET_STUDENT_DATA_SUCCESS,
  GET_STUDENT_DATA_ERROR,
  SELECT_STUDENT,
  SELECT_ALL_STUDENTS,
  UPDATE_SELECTED_VIEW,
} from "./actions";
import { studentState, student } from "./state";
import { map } from "lodash";

export const initialStudentState = {
  students: null,
  totalCount: null,
  studentDataSearch: null,
  selectedViewId: null,
  loading: null,
  error: null,
};

//remember to avoid mutation within reducers
export function students(state = initialStudentState, Actions): studentState {
  switch (Actions.type) {
    case GET_STUDENT_DATA:
      return { ...state, loading: true, studentDataSearch: Actions.payload };
    case GET_STUDENT_DATA_SUCCESS:
      return {
        ...state,
        students: Actions.payload.students,
        totalCount: Actions.payload.totalCount,
        loading: false,
        error: null,
      };
    case GET_STUDENT_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error:
          "There was an error in loading your student data! Please try again later.",
      };
    case SELECT_STUDENT:
      let students = map(state.students, (student: student) => {
        if (student.studentKEY == Actions.payload) {
          return { ...student, selected: !student.selected };
        } else {
          return student;
        }
      });
      return { ...state, students: students };
    case SELECT_ALL_STUDENTS:
      let selectAllStudents = map(state.students, (student: student) => {
        return { ...student, selected: Actions.payload };
      });
      return { ...state, students: selectAllStudents };
    case UPDATE_SELECTED_VIEW:
      return { ...state, selectedViewId: Actions.payload };
  }
}
